import API from '../index';
import { Order } from '../../types/common';

const applyCoupon = async (orderId: string, couponCode: string): Promise<Order> => {
  const data: Order = await API.post(`/orders/${orderId}/coupon`, { coupon: couponCode });
  return data;
};

export default applyCoupon;
